/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_PlatinumInputs */

const id_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const ms_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const da_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const de_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platin`)
};

const en_us2_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const es_es2_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino`)
};

const es_mx2_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino`)
};

const fil_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const fr_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platine`)
};

const it_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platino`)
};

const hu_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const nl_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const no_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platinum`)
};

const pl_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platyna`)
};

const pt_br2_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const pt_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const ro_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platină`)
};

const fi_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const sv_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const vi_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạch kim`)
};

const tr_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platin`)
};

const cs_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina`)
};

const bg_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платина`)
};

const ru_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платина`)
};

const uk_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платина`)
};

const ar_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلاتين`)
};

const hi_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लैटिनम`)
};

const th_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตตินัม`)
};

const ja_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラチナ`)
};

const zh_cn2_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白金成就`)
};

const zh_hant1_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白金成就`)
};

const ko_profile_hero_platinum = /** @type {(inputs: Profile_Hero_PlatinumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플래티넘`)
};

/**
* | output |
* | --- |
* | "Platinum" |
*
* @param {Profile_Hero_PlatinumInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_platinum = /** @type {((inputs?: Profile_Hero_PlatinumInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_PlatinumInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_platinum(inputs)
	if (locale === "ms") return ms_profile_hero_platinum(inputs)
	if (locale === "da") return da_profile_hero_platinum(inputs)
	if (locale === "de") return de_profile_hero_platinum(inputs)
	if (locale === "en-US") return en_us2_profile_hero_platinum(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_platinum(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_platinum(inputs)
	if (locale === "fil") return fil_profile_hero_platinum(inputs)
	if (locale === "fr") return fr_profile_hero_platinum(inputs)
	if (locale === "it") return it_profile_hero_platinum(inputs)
	if (locale === "hu") return hu_profile_hero_platinum(inputs)
	if (locale === "nl") return nl_profile_hero_platinum(inputs)
	if (locale === "no") return no_profile_hero_platinum(inputs)
	if (locale === "pl") return pl_profile_hero_platinum(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_platinum(inputs)
	if (locale === "pt") return pt_profile_hero_platinum(inputs)
	if (locale === "ro") return ro_profile_hero_platinum(inputs)
	if (locale === "fi") return fi_profile_hero_platinum(inputs)
	if (locale === "sv") return sv_profile_hero_platinum(inputs)
	if (locale === "vi") return vi_profile_hero_platinum(inputs)
	if (locale === "tr") return tr_profile_hero_platinum(inputs)
	if (locale === "cs") return cs_profile_hero_platinum(inputs)
	if (locale === "bg") return bg_profile_hero_platinum(inputs)
	if (locale === "ru") return ru_profile_hero_platinum(inputs)
	if (locale === "uk") return uk_profile_hero_platinum(inputs)
	if (locale === "ar") return ar_profile_hero_platinum(inputs)
	if (locale === "hi") return hi_profile_hero_platinum(inputs)
	if (locale === "th") return th_profile_hero_platinum(inputs)
	if (locale === "ja") return ja_profile_hero_platinum(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_platinum(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_platinum(inputs)
	return ko_profile_hero_platinum(inputs)
});
export { profile_hero_platinum as "profile.hero.platinum" }